const getOrder = (item) => {
  const props = (item && item.extendedProps) || {};
  return String((item && item.order) || props.order || "").trim();
};

export const hasTechnicianPaymentHn = (booking) =>
  Boolean(
    String(((booking && booking.extendedProps) || {}).hn || "").trim(),
  );

const getPaymentEntryStudyType = (entry) => {
  const props = (entry && entry.extendedProps) || {};
  return String(
    (entry && (entry.type || entry.studyType)) ||
      props.type ||
      props.studyType ||
      "",
  )
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
};

const getPaymentCaseType = (entry) => {
  const studyType = getPaymentEntryStudyType(entry);

  if (["full night sleep study", "full night"].includes(studyType)) {
    return "fullNight";
  }

  if (["split night sleep study", "split night"].includes(studyType)) {
    return "splitNight";
  }

  return "other";
};

const getOtherCaseTypeCode = (entry) => {
  const studyType = getPaymentEntryStudyType(entry);
  const studyTypeCodes = {
    "home full night sleep study": "HN",
    "cpap titration": "CT",
    "cpap titration study": "CT",
    "overnight pulse oximetry study": "OPO",
    "multiple sleep latency test": "MSLT",
  };

  return studyTypeCodes[studyType] || studyType.toUpperCase() || "Unknown";
};

const addRecordCaseCount = (counts, entry) => {
  const caseType = getPaymentCaseType(entry);

  counts.record += 1;
  if (caseType === "fullNight") counts.recordFullNight += 1;
  if (caseType === "splitNight") counts.recordSplitNight += 1;
  if (caseType === "other") {
    counts.recordOther += 1;
    const otherCaseType = getOtherCaseTypeCode(entry);
    const otherCaseTypes = counts.recordOtherTypes;
    otherCaseTypes[otherCaseType] = (otherCaseTypes[otherCaseType] || 0) + 1;
  }
};

export const formatTechnicianPaymentOtherCaseBreakdown = (
  otherCaseTypes = {},
) => {
  const details = Object.entries(otherCaseTypes || {})
    .filter(([, count]) => Number(count) > 0)
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([caseType, count]) => `${caseType} ${count}`);

  return details.join(" · ") || "No other cases";
};

export const getTechnicianPaymentPhaseCounts = (entries = []) =>
  (entries || []).reduce(
    (counts, entry) => {
      ((entry && entry.phases) || []).forEach((phase) => {
        if (phase.phase === "record") {
          addRecordCaseCount(counts, entry);
        }
        if (phase.phase === "score") counts.score += 1;
      });
      return counts;
    },
    {
      record: 0,
      recordFullNight: 0,
      recordSplitNight: 0,
      recordOther: 0,
      recordOtherTypes: {},
      score: 0,
    },
  );

export const getTechnicianPaymentCandidateOrders = ({
  activities = [],
  bookings = [],
  startYMD,
  endYMD,
}) => {
  const activityOrders = activities.map(getOrder).filter(Boolean);
  const scheduledOrders = bookings
    .filter((booking) => {
      const studyDate =
        ((booking && booking.extendedProps) || {}).latestSleepStudyDate || "";
      return studyDate >= startYMD && studyDate <= endYMD;
    })
    .map(getOrder)
    .filter(Boolean);

  return [...new Set([...activityOrders, ...scheduledOrders])];
};
